export default "__VITE_ASSET__CxW8NviB__"